import { prepareAxiosErrorDataInterceptor } from '@hh.ru/sentry-js';

export default prepareAxiosErrorDataInterceptor(!process.env.SSR && window.globalVars?.features?.sentry_logging);
